import { render, staticRenderFns } from "./OrderedStorefrontItemsReport.vue?vue&type=template&id=846f40da"
import script from "./OrderedStorefrontItemsReport.vue?vue&type=script&lang=js"
export * from "./OrderedStorefrontItemsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports